import React, { useState, lazy } from 'react';
import { MapPin, Phone, Mail } from 'lucide-react';
export function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // Handle form submission
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <section className="py-16 px-4 bg-white" data-id="element-370">
      <div className="max-w-6xl mx-auto" data-id="element-371">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-372">
          {/* Left Column - Map and Contact Info */}
          <div className="space-y-8" data-id="element-373">
            {/* Map */}
            <div className="rounded-xl overflow-hidden shadow-lg border-2 border-[#a3d977]/20" data-id="element-374">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2684.8668!2d-122.2892!3d47.8208!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x549009d5d5d5d5d5%3A0x5d5d5d5d5d5d5d5!2s3815%20196th%20St%20SW%20%23109%2C%20Lynnwood%2C%20WA%2098036!5e0!3m2!1sen!2sus!4v1234567890" width="100%" height="350" style={{
              border: 0
            }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="NWBBA Location" data-id="element-375"></iframe>
            </div>

            {/* Contact Information */}
            <div className="space-y-6" data-id="element-376">
              <div className="flex items-start gap-4 p-6 bg-gray-50 rounded-xl border-2 border-[#a3d977]/20" data-id="element-377">
                <MapPin className="w-6 h-6 text-[#1e3a8a] shrink-0 mt-1" data-id="element-378" />
                <div data-id="element-379">
                  <h3 className="font-bold text-[#0f1f3d] mb-1" data-id="element-380">Address</h3>
                  <p className="text-gray-600" data-id="element-381">
                    3815 196th St SW #109
                    <br data-id="element-382" />
                    Lynnwood, WA 98036
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 p-6 bg-gray-50 rounded-xl border-2 border-[#a3d977]/20" data-id="element-383">
                <Phone className="w-6 h-6 text-[#1e3a8a] shrink-0 mt-1" data-id="element-384" />
                <div data-id="element-385">
                  <h3 className="font-bold text-[#0f1f3d] mb-1" data-id="element-386">Phone</h3>
                  <a href="tel:+14252458651" className="text-gray-600 hover:text-[#1e3a8a] transition-colors" data-id="element-387">
                    (425) 245-8651
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4 p-6 bg-gray-50 rounded-xl border-2 border-[#a3d977]/20" data-id="element-388">
                <Mail className="w-6 h-6 text-[#1e3a8a] shrink-0 mt-1" data-id="element-389" />
                <div data-id="element-390">
                  <h3 className="font-bold text-[#0f1f3d] mb-1" data-id="element-391">Email</h3>
                  <a href="mailto:nwblackbelt@gmail.com" className="text-gray-600 hover:text-[#1e3a8a] transition-colors" data-id="element-392">
                    nwblackbelt@gmail.com
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Contact Form */}
          <div data-id="element-393">
            <div className="bg-[#0f1f3d] p-8 rounded-2xl shadow-xl border-2 border-[#a3d977]/30" data-id="element-394">
              <h2 className="text-3xl font-black text-white mb-6" data-id="element-395">
                Send Us a Message
              </h2>

              <form onSubmit={handleSubmit} className="space-y-4" data-id="element-396">
                <div data-id="element-397">
                  <label htmlFor="name" className="sr-only" data-id="element-398">
                    Your Name
                  </label>
                  <input type="text" id="name" name="name" placeholder="Your Name" value={formData.name} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:ring-2 focus:ring-[#a3d977] focus:border-[#a3d977] outline-none transition-all" required data-id="element-399" />
                </div>

                <div data-id="element-400">
                  <label htmlFor="email" className="sr-only" data-id="element-401">
                    Your Email
                  </label>
                  <input type="email" id="email" name="email" placeholder="Your Email" value={formData.email} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:ring-2 focus:ring-[#a3d977] focus:border-[#a3d977] outline-none transition-all" required data-id="element-402" />
                </div>

                <div data-id="element-403">
                  <label htmlFor="mobile" className="sr-only" data-id="element-404">
                    Your Mobile Number
                  </label>
                  <input type="tel" id="mobile" name="mobile" placeholder="Your Mobile Number" value={formData.mobile} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:ring-2 focus:ring-[#a3d977] focus:border-[#a3d977] outline-none transition-all" required data-id="element-405" />
                </div>

                <div data-id="element-406">
                  <label htmlFor="message" className="sr-only" data-id="element-407">
                    Your Message
                  </label>
                  <textarea id="message" name="message" placeholder="Your Message" value={formData.message} onChange={handleChange} rows={5} className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:ring-2 focus:ring-[#a3d977] focus:border-[#a3d977] outline-none transition-all resize-none" required data-id="element-408"></textarea>
                </div>

                <button type="submit" className="w-full py-4 bg-[#dc2626] text-white font-bold rounded-lg shadow-md hover:bg-red-700 transition-colors text-lg border-2 border-[#a3d977]/30" data-id="element-409">
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>;
}